<!-- HOME PAGE -->
<div class="container">
  <!-- HEADER PAGE -->

  <!-- ROW TITLE AND CLIP -->
  <div fxLayout="row wrap" fxLayoutAlign="center center">
    <div fxFlex.xl="60" fxFlex.lg="60" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="90">

      <!-- TITLE -->
      <div class="title alicent">
        Our specialty is your data
      </div>

      <!-- COLONNE FLEX TEASER RESPONSIVE -->
      <div fxLayout="column" fxLayoutAlign="center" class="posttitle">
        <div class="teaser">
          <iframe
            [src]="urlSafe"
            frameborder="0"></iframe>
        </div>
      </div>

    </div>
  </div>

  <!-- ROW INTRO AND ANIM -->
  <div fxLayout="row wrap" fxLayoutAlign="center center" class="rowdiv">
    <div fxFlex.xl="29" fxFlex.lg="29" fxFlex.md="29" fxFlex.sm="90" fxFlex.xs="90">

      <!-- INTRO -->
      <div class="paragraph">

        <p>Equipped with the best-in-class tools for <span>data collection</span>,
          <span>reporting</span> and
          <span>visualization</span>, <span>study documents de-identification</span>, <span>sites & users
            management</span>, <span>email notifications</span>, <span>direct data management</span>, and much more –
          EDClin™ is the perfect solution for anyone hunting for a <span>superior digital solution</span>
          to power clinical trials and PMCFs. Our clients range from the classic pharmaceutical companies and medtech
          SMEs
          to academic and government organizations, <span>for which we provide a spectrum of services</span> ranging
          from
          basic data-entry of paper forms to full electronic collection of data from multinational, multicentric
          trials.
        </p>
        <br>
        <p>EDClin™ provides <span>a wide array of
            features</span>,
          including:</p>
        <ul class="list">
          <li>The possibility to export all your data to a tailored user-friendly accessible office tool format
            (Excel,
            PDF)</li>
          <li>The possibility to export all your data to a statistical analysis-ready format (SAS)</li>
          <li>The generation of a PDF version for all of your subjects CRFs</li>
          <li>Customizable email alerts</li>
          <li>Two-factor authentication</li>
        </ul>
      </div>
    </div>

    <!-- SPACER -->
    <div fxFlex.xl="2" fxFlex.lg="2"></div>

    <!-- ANIMATION -->
    <div fxFlex.xl="29" fxFlex.lg="29" fxFlex.md="29" fxFlex.sm="90" fxFlex.xs="90">
      <div class="rowdiv wrapper">
        <img class="img-responsive" src="assets/medias/img/dataflow.webp" alt="dataflow">
      </div>
    </div>
  </div>


  <!-- ROW CAROUSEL -->
  <div fxLayout="row wrap" fxLayoutAlign="center">
    <div fxFlex="100">

      <!-- TITLE -->
      <div class="title alicent">
        They trust us

        <!-- CAROUSEL -->
        <div class="posttitle">
          <mat-carousel timings="300ms ease-in" [autoplay]="true" interval="4000" proportion="15" slides="3"
            [loop]="true" [hideArrows]="true" [hideIndicators]="true" [useKeyboard]="true" [useMouseWheel]="false"
            orientation="ltr">
            <mat-carousel-slide #matCarouselSlide *ngFor="let slide of slides; let i = index" [image]="slide.img"
              [hideOverlay]="true"></mat-carousel-slide>
          </mat-carousel>
        </div>
      </div>
    </div>
  </div>
</div>


<app-footer></app-footer>
